import { LoginForm } from '@/features/login-form';
import { ProjectSwitcher } from '@/features/project-switcher';
import { projectConfigs } from '@/shared/config/projects';
import { useCurrentProject } from '@/shared/projects/project-path';

import styles from './auth-page.module.scss';

export const AuthPage = () => {
  const project = useCurrentProject();

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{projectConfigs[project].label}</h1>
      <ProjectSwitcher />
      <LoginForm />
    </div>
  );
};
